import React from "react";
import {Helmet} from "react-helmet";

const MetaTitle = ({title}) => {
    return (
        <div className="application">
            <Helmet>
                <meta charSet="utf-8" />
                <title className="text-capitalize">{title}</title>
                <link rel="canonical" href="http://mysite.com/example" />
            </Helmet>
        </div>
    );
}

export default MetaTitle